const SearchIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M27.55 29.075L21.25 22.8C20.75 23.2167 20.175 23.5417 19.525 23.775C18.875 24.0083 18.2083 24.125 17.525 24.125C15.8083 24.125 14.3583 23.5333 13.175 22.35C11.9917 21.1667 11.4 19.7167 11.4 18C11.4 16.3 11.9917 14.8583 13.175 13.675C14.3583 12.475 15.8083 11.875 17.525 11.875C19.225 11.875 20.6667 12.4667 21.85 13.65C23.0333 14.8333 23.625 16.2833 23.625 18C23.625 18.7167 23.5083 19.4 23.275 20.05C23.0417 20.7 22.725 21.2667 22.325 21.75L28.6 28.025L27.55 29.075ZM17.525 22.625C18.8083 22.625 19.8917 22.175 20.775 21.275C21.675 20.375 22.125 19.2833 22.125 18C22.125 16.7167 21.675 15.625 20.775 14.725C19.8917 13.825 18.8083 13.375 17.525 13.375C16.225 13.375 15.125 13.825 14.225 14.725C13.3417 15.625 12.9 16.7167 12.9 18C12.9 19.2833 13.3417 20.375 14.225 21.275C15.125 22.175 16.225 22.625 17.525 22.625Z"
				fill="white"
			/>
		</svg>
	)
}

export default SearchIcon
